import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireWorkspace = true, requireRole, denyRoles }) {
  const { user, member, loading } = useAuth();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if (requireWorkspace && !member) {
      navigate("/onboarding", { replace: true });
      return;
    }
    if (requireRole && member && member.role !== requireRole && requireRole !== "any") {
      navigate("/forbidden", { replace: true });
      return;
    }
    // Step B — hiring managers are strictly interview-scoped. They may only
    // hit the interviews list, interview detail, and the invite/forbidden
    // helpers. Every other authenticated route bounces them to their
    // assigned interviews list.
    if (denyRoles && member && denyRoles.includes(member.role)) {
      navigate("/interviews", { replace: true });
      return;
    }
    setReady(true);
  }, [loading, user, member, requireWorkspace, requireRole, denyRoles, navigate]);

  if (loading || !ready) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-ink-50">
        <Loader2 className="h-5 w-5 animate-spin text-ink-400" strokeWidth={1.5} />
      </div>
    );
  }
  return children;
}
